"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLog = exports.default = exports.Provider = exports.LogProvider = exports.Consumer = void 0;
var React = _interopRequireWildcard(require("react"));
var logger = _interopRequireWildcard(require("./logger"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const contextDefault = {
  log: () => new Promise(() => {}),
  globals: {},
  setGlobals: () => {}
};
const context = /*#__PURE__*/React.createContext(contextDefault);
context.displayName = "LogNitroContext";
const {
  Consumer,
  Provider
} = context;
exports.Provider = Provider;
exports.Consumer = Consumer;
const LogProvider = _ref => {
  let {
    children,
    initial = {}
  } = _ref;
  const [globals, setGlobals] = React.useState(initial);
  const handleLog = React.useCallback((ev, props) => logger.log(ev, props, globals).catch(() => {}), [globals]);
  const handleSetStatics = React.useCallback(globals => {
    setGlobals(state => ({
      ...state,
      ...globals
    }));
  }, []);
  const value = React.useMemo(() => ({
    log: handleLog,
    globals,
    setGlobals: handleSetStatics
  }), [handleLog, globals, handleSetStatics]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.LogProvider = LogProvider;
const useLog = () => {
  const logContext = React.useContext(context);
  if (logContext == null) {
    throw new Error("No context found for LogNitroContext, did you forget the LogProvider?");
  }
  return logContext;
};
exports.useLog = useLog;
var _default = exports.default = context;